module.exports = __webpack_public_path__ + "media/images/pic/brodno/not_just_courses-942ac8a5079b2c12a741180f388adfa7.svg";